(function() {
	'use strict';

	angular.module('quantixApp').controller(
			'AngularComponentsController', AngularComponentsController);

	AngularComponentsController.$inject = [ '$stateParams', '$scope',
			'GenericService', 'ivhTreeviewMgr', 'ivhTreeviewBfs',
			'ivhTreeviewOptions', '$http', '$timeout' ];

	function AngularComponentsController($stateParams, $scope, GenericService,
			ivhTreeviewMgr, ivhTreeviewBfs, ivhTreeviewOptions, $http, $timeout) {
		var vm = this;
		//vm.controller = controller;
		$scope.data1 = [{
			  values: [20, 30, 25,25],
			  labels: ['score-1', 'score-2', 'score-3','score-4'],
			 
			  marker: {         // marker is an object, valid marker keys: #scatter-marker
				  colors: ['red','green','yellow','blue'] // more about "marker.color": #scatter-marker-color
	            },
			  type: 'pie',
			  hoverinfo : 'label+value',
			text:['score-1', 'score-2', 'score-3','score-4']
			}];

			$scope.layout1 = {
			  height: 380,
			  width: 480
			};
			
			
			$scope.data2 = [
			        {
			            type: 'scatter',  // all "scatter" attributes: https://plot.ly/javascript/reference/#scatter
			            x: [1, 2, 3],     // more about "x": #scatter-x
			            y: [3, 1, 6],     // #scatter-y
			            marker: {         // marker is an object, valid marker keys: #scatter-marker
			                color: 'rgb(16, 32, 77)' // more about "marker.color": #scatter-marker-color
			            }
			        },
			        {
			            type: 'bar',      // all "bar" chart attributes: #bar
			            x: [1, 2, 3],     // more about "x": #bar-x
			            y: [3, 1, 6],     // #bar-y
			            name: 'bar chart example' // #bar-name
			        }
			    ];

			$scope.layout2 = {                     // all "layout" attributes: #layout
			        title: 'simple example',  // more about "layout.title": #layout-title
			        xaxis: {                  // all "layout.xaxis" attributes: #layout-xaxis
			            title: 'time'         // more about "layout.xaxis.title": #layout-xaxis-title
			        },
			        annotations: [            // all "annotation" attributes: #layout-annotations
			            {
			                text: 'simple annotation',    // #layout-annotations-text
			                x: 0,                         // #layout-annotations-x
			                xref: 'paper',                // #layout-annotations-xref
			                y: 0,                         // #layout-annotations-y
			                yref: 'paper'                 // #layout-annotations-yref
			            }
			        ]
			    }	
			
			
			$scope.arr=[{country:'Albania',year:'2007',pop:'3600523',continent:'Europe',lifeExp:'28.801',gdpPercap:'179.445'},
			            {country:'Albania',year:'2007',pop:'2600523',continent:'Europe',lifeExp:'38.801',gdpPercap:'279.445'},
			            {country:'Albania',year:'2007',pop:'1600523',continent:'Europe',lifeExp:'48.801',gdpPercap:'779.445'},
			            {country:'Albania',year:'2007',pop:'5600523',continent:'Europe',lifeExp:'58.801',gdpPercap:'879.445'},
			            {country:'Albania',year:'2007',pop:'6600523',continent:'Europe',lifeExp:'68.801',gdpPercap:'979.445'},
			            {country:'Albania',year:'2007',pop:'8600523',continent:'Europe',lifeExp:'78.801',gdpPercap:'679.445'}
			            
			]
			
			
		//	Plotly.d3.csv('https://raw.githubusercontent.com/plotly/datasets/master/gapminderDataFiveYear.csv', function(err, rows){
				var YEAR = 2007;
				var continents = ['Asia', 'Europe', 'Africa', 'Oceania', 'Americas'];
				var POP_TO_PX_SIZE = 2e4;
				function unpack(rows, key) {
				  return rows.map(function(row) { return row[key]; });
				}

				$scope.data3 = continents.map(function(continent) {
				  var rowsFiltered = $scope.arr.filter(function(row) {
				      return (row.continent === continent) && (+row.year === YEAR);
				  });
				  return {
				      mode: 'markers',
				      name: continent,
				      x: unpack(rowsFiltered, 'lifeExp'),
				      y: unpack(rowsFiltered, 'gdpPercap'),
				      text: unpack(rowsFiltered, 'country'),
				      marker: {
				          sizemode: 'area',
				          size: unpack(rowsFiltered, 'pop'),
				          sizeref: POP_TO_PX_SIZE,
				          color: 'rgb(16, 32, 77)'
				      }
				  };
				});
				$scope.layout3 = {
				  xaxis: {title: 'Life Expectancy'},
				  yaxis: {title: 'GDP per Capita', type: 'log'},
				  margin: {t: 20},
				  hovermode: 'closest'
				};
			//	Plotly.plot('my-graph', data, layout, {showLink: false});
				//});
			
			
	/*		
			var POP_TO_PX_SIZE = 2e5;
			$scope.data3 =  {
				      mode: 'markers',
				      name: 'abc',
				      x: [10,20,30,40,50],
				      y: [1,2,3,4,5],
				      text: ['A','B','C','D','E'],
				      marker: {
				          sizemode: 'area',
				          size:6,
				          sizeref: POP_TO_PX_SIZE
				      }
				  };
				
			$scope.layout3 = {
				  xaxis: {title: 'Life Expectancy'},
				  yaxis: {title: 'GDP per Capita', type: 'log'},
				  margin: {t: 20},
				  hovermode: 'closest'
				};
			
			
			*/
			
			
			

			//Plotly.newPlot('myDiv', data, layout);

		
		
		var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;

		var industryGrid = null;

		$scope.expandDataprod = function() {
			//alert("filter state chnaged");
			//industryGrid.expandAll();
			industryGrid.expandToLevel(5);
			industryGrid.validateNow();
		}

		$scope.onIndustryGridCreationCompleted = function(event) {
			industryGrid = event.target;
			industryGrid.validateNow();
		};

		$scope.onIndustryDynamicLevelCreated = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};
		$scope.selectAllflag = false;
		$scope.selectAll = function(flag) {
			if (flag) {
				arrayprod=[]
				$scope.selectedProducts = [];
				var allkeys=[];
				$scope.selectAllflag = true;
				ivhTreeviewBfs($scope.prodTreeData, opts, function(node) {
					allkeys.push(node.id);
					});
				
				$timeout(function() {
					industryGrid.setSelectedKeys(allkeys, false);
				}, 100);

				industryGrid.setSelectedObjects($scope.prodTreeData, false);

			} else {
				arrayprod=[];
				$scope.selectedProducts = [];
				$scope.selectAllflag = false;
				industryGrid.clearSelection();
				//alert($scope.selectedProducts);
			}
		}
	/*	GenericService.getMasterProductTreeData.productList({}, function(
				data) {
			if (data[0] != null) {
				$scope.prodTreeData = JSON.parse(data[0]);

				$scope.industryOptions = {
						dataProvider : $scope.prodTreeData,
						delegate : $scope
					};
				}
		}); */
		
		$scope.setLocationTree = function() {
			$scope.locationstatus = true;
			
			$timeout(function(){	$scope.industryOptions = {
					dataProvider : $scope.prodTreeData,
					delegate : $scope
				};},100)
			
		}
		var arrayprod = [];
		$scope.selectedProducts = [];
		$scope.badgeString = '';
		$scope.setbadgesforproduct = function(evt) {

			var grid = evt.target;
			if (evt.isItemSelected) {
				arrayprod.push(evt.item.label);
				
			} else {
				arrayprod.splice(arrayprod.indexOf(evt.item.label), 1);
			}

			
			$timeout(function() {
				$scope.selectedProducts = arrayprod;

				$scope.badgeString = $scope.selectedProducts.toString();

			}, 100);

			
		}

		//for lidor tree
		//new tree add
		/*$scope.treeName = "treeSample";
		
		initTheme($scope, IntegralUITreeViewService, $scope.treeName);

		$scope.checkBoxSettings = {
			autoCheck: true,
			threeState: true
		}*/
		$scope.data = [];
		/* GenericService.getIndustryTreeDataModuleWise.getIndustryTree({moduleName : 'SME'}, function(data) {
				if (data[0] != null) {

					$scope.sampledata = JSON.parse(data[0]);
					
				
					
					ivhTreeviewBfs($scope.sampledata, opts, function(node) {
						var tempnpde=angular.copy(node);
						tempnpde.text=node.label;
						tempnpde.pid=node.parentId;
						tempnpde.items=node.children;
						tempnpde.id=node.id;
						$scope.data.push(tempnpde);
						
					});

				}
			});*/
		$scope.show = false;
		$scope.localdata = [];
		/* $http.get('/api/masterData/getMasterProductTreeDataTemp').then(function(response){
			 $scope.localdata = response.data;
			   $timeout(function(){
			    	 
			    	 $scope.data = $scope.localdata;
			    	// alert( $scope.localdata);
			    	 $scope.show=true;
			     },10);
		 }, function(response){alert("in error");});*/

		/*
		 $scope.data = [
		 { 
		 id: 1,
		 text: "Books",
		 icon: "icons-medium library",
		 items: [
		 { id: 11, pid: 1, text: "Art"  },
		 { 
		 id: 12,
		 pid: 1,
		 text: "Business",
		 icon: "icons-medium people",
		 items: [
		 { id: 121, pid: 12, text: "Economics" },
		 { 
		 id: 122,
		 pid: 12,
		 checkState: 'checked',
		 text: "Investing", 
		 expanded: false,
		 icon: "icons-medium economics",
		 items: [
		 { id: 1221, pid: 122, text: "Bonds" },
		 { id: 1222, pid: 122, text: "Options" },
		 { id: 1223, pid: 122, text: "Stocks" }
		 ]
		 },
		 { id: 123, pid: 12, text: "Management" },
		 { id: 124, pid: 12, text: "Small Business" }
		 ]
		 },
		 { id: 13, pid: 1, text: "Health", icon: "icons-medium heart", checkState: 'checked' },
		 { id: 14, pid: 1, text: "Literature" },
		 { 
		 id: 15,
		 pid: 1,
		 text: "Science",
		 expanded: false,
		 items: [
		 { id: 151, pid: 15, text: "Astronomy" },
		 { id: 152, pid: 15, text: "Mathematics" },
		 { id: 153, pid: 15, text: "Evolution" },
		 { id: 154, pid: 15, text: "Nature" }
		 ]
		 }
		 ]
		 },
		 { id: 2, text: "Computers" },
		 {
		 id: 3,
		 checkState: 'checked',
		 text: "Electronics",
		 items: [
		 { id: 31, pid: 3, text: "Camera", icon: "icons-medium camera" },
		 { id: 32, pid: 3, text: "Cell Phones" },
		 { id: 33, pid: 3, text: "Video Game Consoles" }
		 ]
		 },
		 { 
		 id: 4,
		 text: "Music", 
		 expanded: false,
		 icon: "icons-medium album",
		 items: [
		 { id: 41, pid: 4, text: "Blues" },
		 { id: 42, pid: 4, text: "Classic Rock" },
		 { id: 43, pid: 4, text: "Pop" },
		 { id: 44, pid: 4, text: "Jazz" }
		 ]
		 },
		 { 
		 id: 5,
		 text: "Software",
		 icon: "icons-medium software",
		 items: [
		 { id: 51, pid: 5, text: "Games", checkState: 'checked' },
		 { id: 52, pid: 5, text: "Operating Systems" },
		 { id: 53, pid: 5, text: "Network & Servers" },
		 { id: 54, pid: 5, text: "Security" }
		 ]
		 },
		 { 
		 id: 6,
		 text: "Sports",
		 expanded: false,
		 icon: "icons-medium sports",
		 items: [
		 { id: 61, pid: 6, text: "Baseball" },
		 { id: 62, pid: 6, text: "Martial Arts", checkState: 'checked' },
		 { id: 63, pid: 6, text: "Running" },
		 { 
		 id: 64,
		 pid: 6,
		 text: "Tennis",
		 expanded: false,
		 items: [
		 { id: 641, pid: 64, text: "Accessories" },
		 { id: 642, pid: 64, text: "Balls" },
		 { id: 643, pid: 64, text: "Racquets" }
		 ]
		 }
		 ]
		 },
		 { id: 7, text: "Video Games" },
		 { id: 8, text: "Watches", icon: "icons-medium clock" }
		 ]; 
		 */
		$scope.itemCheckStateChanging = function(e) {
			if (e.value == 'unchecked')
				e.item.checkState = 'checked';

		}

		//new tree end

		//end 

		//for ivh tree
		$scope.selectedType = 'PRODUCT';
		$scope.onFilterChangeProd = function(str) {

			if (!str) {
				ivhTreeviewBfs($scope.prodTreeData, function(node) {
					node[isExpanded] = node.savedExpandedState;

				});
			}

			if (1 === str.length) {

				ivhTreeviewBfs($scope.prodTreeData, function(node) {
					node.savedExpandedState = node[isExpanded];

				});
				ivhTreeviewMgr.expandRecursive($scope.prodTreeData);

			}

			if (0 === str.length) {

				ivhTreeviewMgr.collapseRecursive($scope.prodTreeData);

			}
		};

		$scope.getProdData = function() {
			angular.extend($scope.prodTreeData, $scope.loadonclick);

		}

		$scope.deselectFromBadgesProd = function(node) {
			ivhTreeviewMgr.deselect($scope.prodTreeData, node);

			if (node.children) {
				ivhTreeviewBfs(node, opts, function(node) {
					if ($scope.selectedProducts.indexOf(node) !== -1) {
						$scope.selectedProducts.splice($scope.selectedProducts
								.indexOf(node), 1);
					}
				});
			} else {
				$scope.selectedProducts.splice($scope.selectedProducts
						.indexOf(node), 1);
			}

		}
		$scope.selectAllprodflag = false;
		//function for select ALl and deselect All
		$scope.selectAllProd = function(temp) {
			$scope.showResult = false;
			$scope.selectedProducts = [];

			if (temp) {
				$scope.noinddata = false;

				$scope.selectAllprodflag = true;

				//	$scope.filterData.AlllocSelected = $scope.All;
				//	alert($scope.AllInd +"   "+$scope.All);

				ivhTreeviewMgr.selectAll($scope.prodTreeData, opts, true);

				//	$scope.selectedProducts.push("Alll location selected");

			} else {

				//
				$scope.selectAllprodflag = false;
				ivhTreeviewMgr.deselectAll($scope.prodTreeData, opts);

			}

		}

		$scope.selectedProducts = [];
		//function that displays selected values on screnn
		$scope.setValuesForBadgesProd = function(node, isSelected, tree) {
			$scope.showResult = false;
			if (isSelected) {

				$scope.noinddata = false;
				$scope.selectedProducts.push(node);

				//add below lines for single value selection tree also remove select all button from template
				/*	$scope.selectedLocations =[];
					ivhTreeviewMgr.deselectAll($scope.sampletreedata, opts);
					ivhTreeviewMgr.select($scope.sampletreedata, node);
					$scope.selectedLocations.push(node); */

			}
			if (!isSelected) {

				if (node.children) {
					ivhTreeviewBfs(node, opts, function(node) {
						if ($scope.selectedProducts.indexOf(node) !== -1) {
							$scope.selectedProducts.splice(
									$scope.selectedProducts.indexOf(node), 1);
						}
					});
				} else {
					$scope.selectedProducts.splice($scope.selectedProducts
							.indexOf(node), 1);
				}

			}

		}

		$scope.selectedprodKeys = '';
		//function to get selected values of locations tree
		$scope.getselectedKeysForProduct = function() {
			//	alert("inside product selected key fun");
			var selectedkeys = [];
			ivhTreeviewBfs($scope.prodTreeData, opts, function(node) {
				//getselectedKeysForProduct
				if (node.selected) {
					selectedkeys.push(node.id);
				}

			});

			//setting values in string form that can be used for java restcalls
			//	alert("insi" +selectedkeys);
			$scope.selectedprodKeys = selectedkeys.toString();
			//	alert("$scope.selectedprodKeys "+$scope.selectedprodKeys);

		}

		$scope.webBrowsersGrouped = [];

		for (var i = 0; i < 100; i++) {

			$scope.webBrowsersGroupedtemp = [
					{
						name : '<strong>All Browsers' + i + '</strong>',
						msGroup : true
					},
					{
						name : '<strong>Modern Web Browsers' + i + '</strong>',
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera' + i + '',
						maker : '(Opera Software)',
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera12' + i + '',
						maker : '(Opera Software)',
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera13' + i + '',
						maker : '(Opera Software)',
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)'

					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)'

					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)'

					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)'

					},
					{
						msGroup : false
					},
					{
						msGroup : false
					},
					{
						msGroup : false
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/internet_explorer.png" />',
						name : 'Internet Explorer' + i + '',
						maker : '(Microsoft)',
						ticked : false,
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)'

					},
					{
						msGroup : false
					},

					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/humano2/32x32/apps/firefox-icon.png" />',
						name : 'Firefox' + i + '',
						maker : '(Mozilla Foundation)',
						ticked : true,
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)'

					},
					{
						msGroup : false
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32x32/safari_browser.png" />',
						name : 'Safari' + i + '',
						maker : '(Apple)',
						ticked : false,
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)'

					},
					{
						msGroup : false
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/google_jfk_icons_by_carlosjj/32/chrome.png" />',
						name : 'Chrome' + i + '',
						maker : '(Google)',
						msGroup : true
					},
					{
						icon : '<img  src="https://cdn1.iconfinder.com/data/icons/fatcow/32/opera.png" />',
						name : 'Opera11' + i + '',
						maker : '(Opera Software)',

					},
					{
						msGroup : false
					},
					{
						msGroup : false
					},
					{
						name : '<strong>Classic Web Browsers</strong>',
						msGroup : true
					},
					{
						icon : '<img  src="http://www.ucdmc.ucdavis.edu/apps/error/nojavascript/images/netscape_icon.jpg" />',
						name : 'Netscape Navigator' + i + '',
						maker : '(Netscape Corporation)'

					},
					{
						icon : '<img  src="http://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Amaya_logo_65x50.png/48px-Amaya_logo_65x50.png" />',
						name : 'Amaya' + i + '',
						maker : '(Inria & W3C)'

					},
					{
						icon : '<img  src="http://upload.wikimedia.org/wikipedia/commons/8/8c/WorldWideWeb_Icon.png" />',
						name : 'WorldWideWeb Nexus' + i + '',
						maker : '(Tim Berners-Lee)',
						ticked : false
					}, {
						msGroup : false
					}, {
						msGroup : false
					} ];

			for (var j = 0; j < $scope.webBrowsersGroupedtemp.length; j++) {
				$scope.webBrowsersGrouped
						.push($scope.webBrowsersGroupedtemp[j]);
			}

		}

		$scope.treearray = [];

		/*	GenericService.getMasterIndustryTreeData.industryList({}, function(
					data) {
				$scope.industryOptions = {
					dataProvider : JSON.parse(data[0]),
					delegate : $scope
				};
		
				$scope.sampletreedata = JSON.parse(data[0]);
				
				$scope.traverseTree($scope.sampletreedata[0]);	
			
				
				
				

			}); */

		$scope.traverseTree = function(jsonObj) {

			function traverse(jsonObj) {
				if (typeof jsonObj == "object") {

					$.each(jsonObj, function(k, v) {
						// k is either an array index or object key
						traverse(v);
					});
				} else {
					// jsonOb is a number or string
				}
			}

			/* for (i in o) {
			        if (!!o[i] && typeof(o[i])=="object") {
			            $scope.traverseTree(o[i] );
			        }
			    } */

			/*if(node.hasOwnProperty('children') && node.children.length > 0 )
			{
				
			var tempnode  =  angular.copy(node);
			tempnode. msGroup= true;
			$scope.treearray.push(tempnode);
			for(var i=0;i<tempnode.children.length;i++)
				{
				tempnode = node.children[i];
				$scope.traverseTree(tempnode);
				}
			
			}
			else
				{
				var tempnode  =  angular.copy(node);
				$scope.treearray.push(tempnode);
				var tempnode1  = {'msGroup': false};
				$scope.treearray.push(tempnode1);
				//$scope.traverseTree(tempnode);
				}  */
		}

		/*	traverse($scope.sampletreedata).foreach(function(x){
			}) */

		vm.models = {
			selected : null,
			lists : {
				"A" : [],
				"B" : []
			}
		};

		// Generate initial model
		for (var i = 1; i <= 3; ++i) {
			vm.models.lists.A.push({
				id : i + 2,
				label : "Item A" + i
			});
			vm.models.lists.B.push({
				id : i + 12,
				label : "Item B" + i
			});
		}

		vm.pieChartData = [ {
			values : [ 19, 26, 55 ],
			labels : [ 'Residential', 'Non-Residential', 'Utility' ],
			type : 'pie'
		} ];

		vm.pieChartLayout = {
			showlegend : false,
			displaylogo : false,
			height : 400,
			width : 320,
			margin : {
				t : 10,
				b : 0,
				l : 10,
				r : 10
			}
		};
		vm.pieChartOptions = {
			displayModeBar : false
		}
		vm.financialData = [ {
			x : [ '3/31/2015', '3/31/2014', '3/31/2013' ],
			y : [ 0.4, 0.6, 0.5 ],
			name : "Operating Profit",
			type : 'bar'
		}, {
			x : [ '3/31/2015', '3/31/2014', '3/31/2013' ],
			y : [ 0.1, 0.2, 0.4 ],
			yaxis : 'y2',
			name : "Operating Profit Margin",
			type : 'lines'
		} ];

		vm.financiallayout = {
			title : 'Double Y Axis Example',
			yaxis : {
				title : 'Operating Profit'
			},
			width : 400,
			yaxis2 : {
				title : 'Operating Profit Margin',
				titlefont : {
					color : 'rgb(148, 103, 189)'
				},
				tickfont : {
					color : 'rgb(148, 103, 189)'
				},
				overlaying : 'y',
				side : 'right'
			}
		};

		vm.scoreCardGraphData = [ {
			x : [ 'Net Sales', 'Networth' ],
			y : [ 1, 1.5 ],
			type : 'bar'
		}, {
			x : [ 'Net Sales', 'Networth' ],
			y : [ 2, 1.2, 16, 17 ],
			mode : 'markers',
			marker : {
				size : [ 400 ],
				// setting 'sizeref' to lower than 1 decreases the rendered size
				sizeref : 2,
				sizemode : 'area'
			}
		} ];

		vm.scoreCardGraphlayout = {
			title : 'Double Y Axis Example',
			showlegend : false,
			displaylogo : false,
			barmode : 'stack',
			legend : {
				x : 0,
				y : 1.0,
				bgcolor : 'rgba(255, 255, 255, 0)',
				bordercolor : 'rgba(255, 255, 255, 0)'
			},
			overlaying : 'x'
		};

		// For Score Card Graph
		vm.sizeScoreData = [

		{
			x : [ 'Net Sales', 'Networth' ],
			y : [ 3252, 4264 ],
			type : 'bar',
			name : 'best',
			hoverinfo : 'name+y',
			marker : {
				color : 'gray',
			},
		}, {
			x : [ 'Net Sales', 'Networth' ],
			y : [ 3264, 1252 ],
			mode : 'markers',
			name : 'Median',
			hoverinfo : 'name+y',

			marker : {
				color : '#333399',
				line : {
					width : '4'
				},
				size : '30',

				symbol : 'line-ew-open'
			},
			type : 'scatter'
		}, {
			x : [ 'Net Sales', 'Networth' ],
			y : [ 4264, 3252 ],
			mode : 'markers',
			name : 'Selected Company',
			hoverinfo : 'name+y',
			tracegroupgap : 15,
			marker : {
				color : '#99CCFF',
				size : 19,
				opacity : 0.9,
				symbol : 'circle',
				line : {
					width : '1',
					color : '#FFFF00',
				}
			},
			type : 'scatter'
		}

		];

		vm.sizeScorelayout = {
			title : 'Size Score',
			titlefont : {
				color : "#444",
				family : "\"Open sans\", verdana, arial, sans-serif",
				size : 17
			},
			hovermode : 'closest',
			displaylogo : false,
			showlegend : true,
			legend : {
				tracegroupgap : 15,
				bordercolor : 'gray',
				borderwidth : 1.8,
				orientation : "h",
				font : {
					family : 'sans-serif',
					size : 12,
					color : '#000'
				},
				xanchor : 'left',
				yanchor : "top"

			},
			autosize : true,
			margin : {
				"r" : 80,
				"t" : 60,
				"autoexpand" : true,
				"b" : 80,
				"l" : 80,
				"pad" : 0
			},
			barmode : 'mixed',
			bargap : 0.96,
			overlaying : 'x',
			yaxis : {
				title : ' Units(%) ',
				hoverformat : '.2r'
			},
			xaxis : {
				tickvals : [ 'Net Sales', 'Networth' ],
				tickangle : 0,
				hoverformat : '.2r'
			},
		};
		vm.sizeScoreOptions = {
			modeBarButtonsToRemove : [ 'sendDataToCloud' ],
			displaylogo : false,
			showLink : false
		};

		// for new

		$scope.country = {};
		$scope.state = {};
		$scope.city = {};
		var allCountries = [ {
			Id : 1,
			CountryName : "USA"
		}, {
			Id : 2,
			CountryName : "Australia"
		} ];
		var allStates = [ {
			Id : 1,
			StateName : "Washington",
			CountryId : 1
		}, {
			Id : 2,
			StateName : "New York",
			CountryId : 1
		}, {
			Id : 3,
			StateName : "Queensland",
			CountryId : 2
		} ];
		var allCities = [ {
			Id : 1,
			CityName : "Washington DC",
			StateId : 1
		}, {
			Id : 2,
			CityName : "New York City",
			StateId : 2
		}, {
			Id : 3,
			CityName : "Brisbane",
			StateId : 3
		} ];

		$scope.countries = allCountries;

		$scope.$watch('country', function() {
			$scope.states = allStates.filter(function(s) {
				return s.CountryId == $scope.country.Id;

			});
			$scope.city = {};
			$scope.state = {};
			$scope.cities = [];
		});

		$scope.$watch('state', function() {
			$scope.cities = allCities.filter(function(c) {
				return c.StateId == $scope.state.Id;
			});
			$scope.city = {};
		});

	}
})();
